<script lang="ts">
  import { COLLECTIONS } from './collections';
  import { collectionArt } from './browse-art';
  import { collectionHref } from './nav.svelte';
  import { DISCOVERY_COLLECTIONS } from './discovery';
  const { compact = false }: { compact?: boolean } = $props();
  const picks = DISCOVERY_COLLECTIONS.flatMap(slug => COLLECTIONS.find(c => c.slug === slug) ?? []);
  let failed = $state<ReadonlySet<string>>(new Set());
</script>

<section class="discovery" class:compact aria-label="Browse collections">
  <header><div><h2>A place to start</h2><p>A few collections for a different kind of evening.</p></div><a href="/movies">Browse all films <span aria-hidden="true">↗</span></a></header>
  <div class="paths">
    {#each picks as collection (collection.slug)}
      <a class="path" href={collectionHref(collection.slug)}>
        {#if !failed.has(collection.slug)}<img src={collectionArt(collection.slug)} alt="" loading="lazy" decoding="async" onerror={() => { failed = new Set([...failed, collection.slug]); }} />{/if}
        <span class="shade" aria-hidden="true"></span>
        <span class="copy"><strong>{collection.label}</strong><span>{collection.note}</span></span>
        <span class="arrow" aria-hidden="true">↗</span>
      </a>
    {/each}
  </div>
</section>

<style>
  .discovery { padding: var(--space-6) max(var(--page-pad), var(--safe-r)) var(--space-5) max(var(--page-pad), var(--safe-l)); }
  header { display: flex; justify-content: space-between; align-items: end; gap: var(--space-4); margin-bottom: var(--space-4); }
  h2 { font-size: var(--text-lg); font-weight: var(--weight-bold); letter-spacing: var(--tracking-snug); }
  p { margin: var(--space-1) 0 0; color: var(--text-dim); font-size: var(--text-sm); line-height: 1.5; }
  header > a { color: var(--text-dim); font-size: var(--text-sm); white-space: nowrap; min-height: var(--hit); display: inline-flex; gap: var(--space-2); align-items: center; }
  header > a:hover { color: var(--text); }
  .paths { display: grid; grid-template-columns: repeat(4,minmax(0,1fr)); gap: var(--space-3); }
  .path { min-height: 148px; position: relative; overflow: hidden; border-radius: var(--radius); isolation: isolate; background: var(--surface-2); color: white; }
  img, .shade { position: absolute; inset: 0; width: 100%; height: 100%; }
  img { object-fit: cover; transition: transform var(--dur-slow) var(--ease); }
  .shade { background: linear-gradient(180deg,rgb(0 0 0 / .1),rgb(0 0 0 / .8)); }
  .copy { position: absolute; inset: auto 40px 18px 18px; display: grid; gap: 5px; }
  strong { font-size: var(--text-md); letter-spacing: var(--tracking-snug); }
  .copy > span { font-size: var(--text-xs); line-height: 1.45; color: rgb(255 255 255 / .85); }
  .arrow { position: absolute; right: 18px; bottom: 19px; font-size: 20px; }
  .path:hover img { transform: scale(1.035); }
  a:focus-visible { outline: 2px solid var(--focus-ring); outline-offset: 4px; }
  .compact { padding-inline: 0; }
  @media (max-width: 767px) {
    .paths { grid-template-columns: repeat(2,minmax(0,1fr)); gap: var(--space-2); }
    .path { min-height: 128px; }
    .copy { inset: auto 25px 13px 13px; }
    .arrow { right: 12px; bottom: 12px; }
    header > a { display: none; }
    .discovery { padding-top: var(--space-5); }
  }
  @media (prefers-reduced-motion: reduce) { img { transition: none; } .path:hover img { transform: none; } }
</style>
